import { render } from "./SideMenu.vue?vue&type=template&id=7cd9e082&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=7cd9e082&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src536781470/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd9e082"]])

export default __exports__